import React from 'react';
import styles from '../Home.module.css';

const About = (props) => {
  const { title } = props;
  return (
    <div className={styles.contentContainer}>
      <div className={styles.about}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.text}>
          Hi, I'm James, a full stack engineer who builds AI-powered systems
          end to end. I work across the entire stack, from designing backend
          services and APIs to crafting the interfaces users interact with, and
          I bring that same breadth to AI engineering. I've built agentic
          workflows, retrieval pipelines, and LLM integrations that run
          reliably in production, not just in notebooks.
        </p>
        <p className={styles.text}>
          My day-to-day spans TypeScript, Node.js, React, and PostgreSQL. I've
          designed hybrid search systems combining vector similarity with
          keyword retrieval, multi-stage ranking pipelines with reranking and
          token budgeting, and memory layers backed by pgvector and Redis. I
          measure what matters, tracking retrieval quality with metrics like
          Recall@K and MRR, and building observability so I know exactly how my
          systems perform under real load.
        </p>
        <p className={styles.text}>
          I've spent years shipping production software across the full stack,
          and that experience is what makes my AI work practical. I don't just
          prototype, I build systems that are architected to scale, easy to
          maintain, and ready for real users.
        </p>
      </div>
    </div>
  );
};

export default About;
